import {
  Errors as PaymentPluginErrors,
  ErrorUserMessages as PaymentPluginErrorUserMessages,
} from '@based/payment-plugin/shared'

export enum EscErrorUserMessages {
  CantConfirmCardCountry = 'cant_confirm_card_country',
  CardNotEligible = 'card_not_eligible',
  CardOrWalletAlreadyVotedInSequence = 'card_or_wallet_already_voted_in_sequence',
  EmailAlreadyUsedInSequence = 'email_already_used_in_sequence',
  CaptchaError = 'captcha_error',
  InvalidEmail = 'invalid_email',
  DisposableEmail = 'disposable_email',
}

export enum EscErrors {
  CantConfirmCardCountry = 'cant_confirm_card_country',
  CardNotEligible = 'card_not_eligible',
  InvalidRequestPaymentPayload = 'invalid_request_payment_payload',
  InvalidPaymentIdToken = 'invalid_payment_id_token',
  PaymentIdDoesNotExist = 'payment_id_does_not_exist',
  CaptchaConfig = 'captcha_config',

  InvalidVoteGeo = 'invalid_vote_geo',
  InvalidScenarioId = 'invalid_scenario_id',
  InvalidVotesFormat = 'invalid_votes_format',
  InvalidSequenceId = 'invalid_sequence_id',
  VoteCountryNotInSequence = 'vote_country_not_in_sequence',
  VoteCountryDisqualified = 'vote_country_disqualified',
  InvalidVoteAmount = 'invalid_vote_amount',
  TooManyVotes = 'too_many_votes',
  RegionConfigWrong = 'region_config_wrong',
  VoteCountrySameAsRegion = 'vote_country_same_as_region',
  VoteCountrySameAsCardRegion = 'vote_country_same_as_card_region',

  SequenceAndFingerprintAlreadyExist = 'sequence_and_fingerprint_already_exist',
  SequenceAndParAlreadyExist = 'sequence_and_par_already_exist',
  SequenceAndEmailAlreadyExist = 'sequence_and_email_already_exist',
  CardOrWalletAlreadyVotedInSequence = 'card_or_wallet_already_voted_in_sequence',
  EmailAlreadyUsedInSequence = 'email_already_used_in_sequence',

  WebhookPriceMismatch = 'webhook_price_mismatch',
  WebhookCurrencyMismatch = 'webhook_currency_mismatch',
  WebhookCountryMismatch = 'webhook_country_mismatch',
}

export const Errors = {
  ...PaymentPluginErrors,
  ...EscErrors,
}

export const ErrorUserMessages = {
  ...PaymentPluginErrorUserMessages,
  ...EscErrorUserMessages,
}
